/**
 * Historical Arrears tiles when the month was never captured (28 Sep 2026).
 *
 * A Historical window reads the arrears frozen at its end month. A site with
 * capture switched off has no such snapshot, and the tiles printed £0 over
 * hundreds of thousands of open arrears — a zero nobody measured. The API now
 * says where the figure comes from (`arrears_value_source`); on `'none'` the
 * tiles print this instead of a number.
 */

/** Where a Historical Arrears figure comes from: `'none'` = the month-end was never captured. */
export type ArrearsValueSource = 'snapshot' | 'none' | 'live';

/** Printed in place of the value when there is no snapshot. */
export const NO_ARREARS_SNAPSHOT = 'No snapshot';

/** One line under it. */
export const NO_ARREARS_SNAPSHOT_FOOT = 'Month-end not captured';

/** Hover text: what happened and where the current figure is. */
export const NO_ARREARS_SNAPSHOT_HINT =
  'No month-end arrears snapshot was captured for the end of this period, so there is no historical figure. '
  + "Switch Data to Live to see today's arrears.";
